import { AuthorSchema, BaseVersionSchema } from '@dl/shared';
import { z } from 'zod';

/**
 * A client-submitted op, prior to server arbitration. Lacks `id` and `hlc`
 * — both are server-assigned at accept time inside the Workspace DO.
 */
export const SubmittedOpSchema = <Payload extends z.ZodTypeAny>(payload: Payload) =>
  z
    .object({
      subject: z.string().min(1),
      predicate: z.string().min(1),
      payload,
      base_version: BaseVersionSchema,
      author: AuthorSchema,
      created_at_real: z.iso.datetime(),
    })
    .strict();

export type SubmittedOp<Payload = unknown> = z.input<
  ReturnType<typeof SubmittedOpSchema<z.ZodType<Payload>>>
>;
